import { useAuthContext } from "../auth/AuthProvider";
import { getUserRoles } from "../utilities/userUtils";

export const useGetRoles = (): string[] => {
    const authContext = useAuthContext();
    return getUserRoles(authContext);
};
